import React, { useEffect, useState } from 'react';
// Components
import Navbar from '../../../components/nav/Navbar';
import NewsletterAdminPageMainContainer from '../../../components/newsletter/admin/NewsletterAdminPageMainContainer';
import { HelmetItem } from '../../../components/utils/HelmetItem';
import PageDivider from '../../../components/gallery/PageDivider';
import GeneralHeader from '../../../components/header/GeneralHeader';

function NewsletterAdminPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById(
        'scroll-section-newsletter-admin-main'
      );
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Newsletter Admin'
        desc='Internal admin page for managing newsletter subscriptions.'
        noIndex={true}
      />

      {/* Page */}
      <div className='grid grid-rows-reg min-h-screen font-main bg-colour1 dark:bg-colour1 text-colour2 dark:text-colour2 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-newsletter-admin-main'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`Newsletter Admin`}
            title={`Manage subs and create`}
          />
        </div>

        {/* Main content */}
        <NewsletterAdminPageMainContainer />
      </div>
    </>
  );
}

export default NewsletterAdminPage;
